import * as Sentry from '@sentry/browser';
import * as SegmentApi from '@hotjar/webapp/domains/segments/api';
import * as hotjarTracking from '@hotjar/webapp/tracking/tools/hotjar';
import { getSegmentById } from './getSegmentById';
import { segmentChanged } from './segmentChanged';
import type { Segment } from '@hotjar/global-filters/src/domains/global-filters/model/segment';

import type { Site } from '@hotjar/site';
import type { Store, JsonFilters } from '../../../store/list/types';

export const deleteSegment = (store: Store, segment: Segment): void => {
  const { site, currentSegment, segments, setCurrentSegment, setSegments } = store.getState();

  SegmentApi.remove((site as Site).id, segment.id)
    .then(() => {
      setSegments(segments.filter((oneSegment) => oneSegment.id !== segment.id));
      hotjarTracking.tagRecording('deleted segment');

      window.dispatchEvent(
        new CustomEvent('hjNotification', {
          detail: {
            cls: 'notification-box-success',
            message: `Deleted segment "${segment.name}"`,
            timeout: 6000,
          },
        }),
      );

      if (segment.id === currentSegment?.id) {
        const { segments } = store.getState();
        const newCurrentSegment = getSegmentById(-1, segments);

        if (!newCurrentSegment) {
          return;
        }

        const newFilterQueryFormat = newCurrentSegment.filters;

        setCurrentSegment(newCurrentSegment);
        segmentChanged(store, newFilterQueryFormat as JsonFilters);
      }
    })
    .catch((e) => {
      Sentry.captureException(e, {
        contexts: {
          section: { name: 'Deleting segment' },
        },
      });

      window.dispatchEvent(
        new CustomEvent('hjNotification', {
          detail: {
            cls: 'notification-box-error',
            message: `Unable to delete segment "${segment.name}"`,
            timeout: 6000,
          },
        }),
      );
    });
};
